<script>
    import { onMount } from "svelte";
    import { push, replace } from 'svelte-spa-router'
    import Modal from "sv-bootstrap-modal";
    import ModalTemplate from "../Modal/Modal.svelte";
    import Confirmation from "../Modal/Confirmation.svelte";
    import Pagination from "../Pagination.svelte";
    import UserApi from "../../api/user";
    import UserProductsApi from "../../api/user_products";
    import UserProjectProductsApi from "../../api/user_project_products";
    import UserProjectsApi from "../../api/user_projects";
    import UserFileApi from "../../api/user_file";
    import UserUnitsApi from "../../api/user_units";
    import UserProductsUnitsApi from "../../api/user_products_units";
    import UserCsvApi from "../../api/user_csv";
    import UserExcelApi from "../../api/user_excel";
    import Report from "../Report.svelte";
    import PrintSettings from "../PrintSettings.svelte";
    import Charts from "../../charts";
    import Util from "../../util";
    import Tooltip from "./../Tooltip.svelte";
    import AutoSavingLoading from "../AutoSavingLoading.svelte";
    //
    export let params = {};
    //
    let userProfile = {};
    let project_id = params.id;
    let isOpenProduct = false;
    let isOpenComplete = false;
    let isOpenReport = false;
    let isOpenCustomize = false;
    let userProducts = [];
    let currentProject = { Nominal: {}, Custom: {}, Entries: [] };
    let userProjectProducts = [];
    let selectedProducts = [];
    let projectProductId = 0;
    let userProjectProductSelectedName = "";

    // Charts
    let projectIsComplete = false;
    let showChartAB = new Boolean(window.localStorage.getItem("showChartAB"));
    let showChartLA = new Boolean(window.localStorage.getItem("showChartLA"));
    let showChartLB = new Boolean(window.localStorage.getItem("showChartLB"));
    let showData = new Boolean(window.localStorage.getItem("showData"));

    let checkboxes;
    let customMeasures = [],
        entryMeasures = [];
    let newEntryMeasure, newCustomMeasure, editEntryMeasure, confirmationProps, component;
    let action;
    let fileUpload;
    let isOpenRowEntry = false,
        isOpenRowCustom = false,
        isOpenConfirmation = false,
        isOpenUpload = false;

    let excelReportURL = undefined;
    let projectimgSrc;
    let name = undefined;
    let saving = false;
    const savingTimeout = 500;

    const goToTop = () => {
        let element = document.getElementById("top");
        element.scrollIntoView();
    };

    const goToColorData = () => {
        let element = document.getElementById("colorData");
        element.scrollIntoView();
    };

    const showCheckboxes = () => {
        checkboxes.style.display = "block";
    };

    const loadUserProducts = async () => {
        try {
            userProducts = await UserProductsApi.getAsync();
        } catch (error) {
            // ..
        }
    };

    const loadUserProjectProducts = async () => {
        try {
            userProjectProducts = await UserProjectProductsApi.getAsync({ projectId: project_id });
            selectedProducts = userProjectProducts.map((item) => item.ID);
            const previousSelected = selectedProducts.find((ID) => ID == projectProductId);
            if (!previousSelected) {
                projectProductId = (userProjectProducts[0] || {}).ID || 0;
            }
        } catch (error) {
            // ..
        }
    };

    const loadUserProjectProductEntries = async () => {
        try {
            Util.showProgress();
            currentProject = await UserProjectsApi.getByIdAsync({ id: project_id, productId: projectProductId });
            if (!currentProject) {
                push("/products");
                setTimeout(() => {
                    window.location.reload();
                }, 1);
                return;
            }
            projectIsComplete = currentProject.Status == "COMPLETE";
            if (currentProject.Custom) {
                customMeasures = [currentProject.Custom.MeasurementL, currentProject.Custom.MeasurementA, currentProject.Custom.MeasurementB, currentProject.Custom.MeasurementD];
            } else if (currentProject.Nominal) {
                customMeasures = [currentProject.Nominal.MeasurementL, currentProject.Nominal.MeasurementA, currentProject.Nominal.MeasurementB, currentProject.Nominal.MeasurementD];
            }

            if (currentProject.Entries) {
                currentProject.Entries.forEach((element, index) => {
                    element["isEditing"] = false;
                });
            }
            // Number, Date, Ticket, L*, a*, b*
            entryMeasures = [, Util.defaultDate, , , , ,];
            isOpenRowCustom = false;
            if (entryCurrentPag == 0) entryCurrentPag = 1;

            await loadCharts();
        } catch (error) {
            // ..
        } finally {
            Util.hideProgress();
        }
    };

    const loadUserProfile = async () => {
        try {
            userProfile = await UserApi.getAsync();
        } catch (error) {
            console.error(error);
        }
    };

    const onBlurName = async () => {
        if (name && name == currentProject.Name) {
            name = undefined;
            return;
        }
        saving = true
        Util.showProgress();
        try {
            const model = Object.keys(currentProject).reduce((acc, key) => {
                acc[key.toLowerCase()] = currentProject[key];
                return acc;
            }, {});
            Object.assign(model, { name: currentProject.Name });
            const data = await UserProjectsApi.patchAsync({ id: project_id }, model);
        } catch (error) {
            //
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const onFocusName = () => {
        name = currentProject.Name;
    }

    const addProducts = async (confirmation_) => {
        // Identify which project products can be deleted from selected list
        const userProjectProductsIds = userProjectProducts.map((i) => i.ID);
        const userProductsIds = userProducts.map((i) => i.ID);
        const userProjectProductsIdsFiltered = userProjectProductsIds.filter(id => userProductsIds.includes(id));
        // Which ones were deleted
        const removed = userProjectProductsIdsFiltered.filter((ID) => !selectedProducts.includes(ID));
        // Which ones were added
        const added = selectedProducts.filter((ID) => !userProjectProductsIdsFiltered.includes(ID));
        // Confirmation logic when products removed
        if (removed.length == 0) confirmation_ = true;
        if (confirmation_)
            try {
                saving = true;
                if (removed.length) {
                    await UserProjectProductsApi.deleteAsync({ projectId: project_id }, removed);
                }
                if (added.length) {
                    await UserProjectProductsApi.putAsync({ projectId: project_id }, added);
                }
                isOpenProduct = false;
                await loadUserProjectProducts();
            } catch (error) {
                console.error(error);
            } finally {
                setTimeout(() => saving = false, savingTimeout);
            }
        else {
            component = Confirmation;
            confirmationProps = {
                btnOk: "Continue",
                message: `There are products that will be deleted, are you sure you want to continue?`,
                confirmFunction: async () => {
                    await addProducts(true);
                    isOpenConfirmation = false;
                },
            };
            isOpenConfirmation = true;
        }
    };

    const addCustom = async () => {
        if (!customMeasures.length) return;
        saving = true;
        try {
            await UserUnitsApi.putAsync(
                { projectId: project_id, productId: projectProductId },
                {
                    measurementL: customMeasures[0],
                    measurementA: customMeasures[1],
                    measurementB: customMeasures[2],
                    measurementD: customMeasures[3],
                }
            );
            isOpenRowCustom = false;
            await loadUserProjectProductEntries();
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const onDeleteCustom = async () => {
        saving = true;
        try {
            await UserUnitsApi.deleteAsync(
                { projectId: project_id, productId: projectProductId }
            );
            await loadUserProjectProductEntries();
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const addEntry = async () => {
        if (!entryMeasures.length) return;
        saving = true;
        try {
            await UserUnitsApi.postAsync(
                { projectId: project_id, productId: projectProductId },
                {
                    number: entryMeasures[0],
                    dateDt: entryMeasures[1],
                    ticket: entryMeasures[2],
                    measurementL: entryMeasures[3],
                    measurementA: entryMeasures[4],
                    measurementB: entryMeasures[5],
                }
            );
            isOpenRowEntry = false;
            await loadUserProjectProductEntries();
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const onCancelEntry = () => {
        isOpenRowEntry = false;
        // Number, Date, Ticket, L*, a*, b*
        entryMeasures = [, Util.defaultDate, , , , ,];
    };

    const setProjectComplete = async (projectId) => {
        saving = true;
        try {
            await UserProjectsApi.putAsync({ id: projectId });
            isOpenComplete = false;
            await loadUserProjectProductEntries();
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const loadCharts = async () => {
        const nominal = currentProject.Nominal || {};
        const custom = currentProject.Custom || {};
        const entries = currentProject.Entries || [];
        let model = {};
        // Load Chart a*b*
        model = await Charts.ab.build({ entries, nominal, custom });
        Charts.load({ elementId: "chartAB", ...model });
        // Load Chart a*L*
        model = await Charts.al.build({ entries, nominal, custom });
        Charts.load({ elementId: "chartAL", ...model });
        // Load Chart b*L*
        model = await Charts.bl.build({ entries, nominal, custom });
        Charts.load({ elementId: "chartBL", ...model });
    };

    const generateReport = async () => {
        let selectProduct = document.getElementById("productSelect");
        const name = selectProduct.options[selectProduct.selectedIndex].text;
        if (name != "<--Add Product-->")
            userProjectProductSelectedName = name;
        await getProjectImage();
        excelReportURL = ColorCalcModule.apiSegment() + `/api/colorcalc/user_excel?project_id=${currentProject.ID}&product_id=${projectProductId}`;
        isOpenReport = true;
    };

    const getProjectImage = async () => {
        try {
            const data = await UserFileApi.getAsync({ projectId: currentProject.ID });
            // Inspect data
            const { size, type } = data;
            projectimgSrc = size ? URL.createObjectURL(data) : null;
        } catch (error) {
            console.error(error);
        }
    };

    const editEntry = async (entry) => {
        let unitId = entry.ID;
        saving = true;
        try {
            await UserUnitsApi.pathAsync(
                { projectId: project_id, productId: projectProductId, unitId },
                {
                    number: entry.Number,
                    dateDt: entry.DateDt,
                    ticket: entry.Ticket,
                    measurementL: entry.MeasurementL,
                    measurementA: entry.MeasurementA,
                    measurementB: entry.MeasurementB,
                }
            );
            isOpenRowEntry = false;
            await loadUserProjectProductEntries();
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const deleteEntry = (name, unitId) => {
        component = Confirmation;
        confirmationProps = {
            btnOk: "Delete",
            message: `Are you sure you want to delete ${name}?`,
            confirmFunction: async () => {
                saving = true;
                try {
                    await UserProductsUnitsApi.deleteAsync({ unitId });
                    isOpenRowEntry = false;
                    await loadUserProjectProductEntries();
                    isOpenConfirmation = false;
                } catch (error) {

                } finally {
                    setTimeout(() => saving = false, savingTimeout);
                }
            },
        };
        isOpenConfirmation = true;
    };

    const setClass = (delta) => {
        if (currentProject.Custom) {
            if (delta > currentProject.Custom.MeasurementD && delta > currentProject.Nominal.MeasurementD) {
                return "bg-danger";
            } else if ((delta > currentProject.Custom.MeasurementD && delta < currentProject.Nominal.MeasurementD) || (delta < currentProject.Custom.MeasurementD && delta > currentProject.Nominal.MeasurementD)) {
                return "bg-warning";
            }
        } else {
            if (delta > currentProject.Nominal.MeasurementD) return "bg-danger";
            else return "";
        }
    };

    const uploadFile = async () => {
        saving = true;
        try {
            Util.showProgress();
            let productId = projectProductId;
            if (!fileUpload.length) return;
            const file = fileUpload[0];
            // CSV type
            if (file.type == "application/vnd.ms-excel" || file.name.includes(".csv")) {
                await UserCsvApi.postAsync({ action, projectId: project_id, productId }, { file });
                isOpenUpload = false;
                await loadUserProjectProductEntries();
            }
            // Excel type
            else {
                await UserExcelApi.postAsync({ action, projectId: project_id, productId }, { file });
                isOpenUpload = false;
                await loadUserProjectProductEntries();
            }
        } catch (error) {
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };

    const saveCustomProject = async ({ project, imageFile, showChartLA: sLA, showChartAB: sAB, showChartLB: sLB, showData: sD }) => {
        showChartLA = sLA;
        showChartAB = sAB;
        showChartLB = sLB;
        showData = sD;

        try {
            const model = Object.keys(project).reduce((acc, key) => {
                acc[key.toLowerCase()] = project[key];
                return acc;
            }, {});
            const data = await UserProjectsApi.patchAsync({ id: project_id }, model);
            await loadUserProjectProductEntries();
            // Save image
            if (imageFile) {
                await UserFileApi.postAsync({ projectId: project_id }, { file: imageFile });
                await getProjectImage();
            }
        } catch (error) {
            //
        }
    };

    const onCustomizeCancel = () => {
        isOpenRowCustom = false;
        if (currentProject.Custom) {
            customMeasures = [currentProject.Custom.MeasurementL, currentProject.Custom.MeasurementA, currentProject.Custom.MeasurementB, currentProject.Custom.MeasurementD];
        }
    };

    const onSaveEmail = () => {
        ColorCalcAnonymousData.show();
    };

    onMount(async () => {
        google.charts.load("current", { packages: ["corechart"] });
        await loadUserProfile();
        await loadUserProducts();
        await loadUserProjectProducts();
        await loadUserProjectProductEntries();
        //
        Util.popoverInit();
    });
    // Observable
    $: if (newEntryMeasure) newEntryMeasure.focus();
    $: if (newCustomMeasure) newCustomMeasure.focus();
    $: if (editEntryMeasure) editEntryMeasure.focus();
    $: if (isOpenUpload) {
        action = "append";
        fileUpload = [];
    }
    $: if (projectProductId) loadUserProjectProductEntries();
    // Pagination
    let entryPag = [],
        entryCurrentPag = 0,
        entryTotalPag = 0,
        entryTotalItems = 0,
        entryItemsPerPag = 10,
        entryItemPagFm = 0,
        entryItemPagTo = 0;

    $: if (entryCurrentPag > 0) {
        entryTotalItems = currentProject.Entries.length;
        entryTotalPag = Math.ceil(entryTotalItems / entryItemsPerPag);
        entryItemPagFm = entryCurrentPag * entryItemsPerPag - entryItemsPerPag;
        entryItemPagTo = entryCurrentPag * entryItemsPerPag;
        entryPag = currentProject.Entries.slice(entryItemPagFm, entryItemPagTo);
    }
    $: if (isOpenProduct) loadUserProjectProducts();
</script>

<Tooltip style="top: 155px; left: 70px; display: none;" position="top" number="1" title="" text="Project: Customize by your project names" />
<Tooltip style="top: 205px; left: 340px; display: none;" position="top" number="2" title=""  text="Method: CIE 76 is the standard used to measure color in 3-D (L*, a*, b*) space" />
<Tooltip style="top: 290px; left: 450px; display: none;" position="right" number="3" title="" text="Project Configuration: You can build various window configurations and assign them to separate Projects" />
<div class="mt-1" style="display: flex;justify-content: flex-end;font-size: 10px;">
    <span>*All changes are autosaved</span>
</div>
<div class="row" id="top">
    <div class="col-12 ml-3">
        <div class="mt-1" style="display: flex">
            <div class="">
                <ol class="breadcrumb">
                    <a href="#/projects"><i class="pe-3 bi bi-arrow-left fs-5" />Glass Color -Diff Calculator</a>
                </ol>
            </div>
            <div class="" style="display: flex; flex: 1">
                <div style="flex: 1;">
                    <AutoSavingLoading {saving} />
                </div>
                {#if !userProfile.Email}
                    <button on:click|preventDefault={onSaveEmail} type="button" class="btn  btn-outline-blue btn-sm me-1"
                        title="Associate an email to your current progress and retrieve it later by using 'Retrieve Data'">
                        Save Progress
                    </button>
                {/if}
                {#if projectIsComplete}
                    <button type="button" class="btn  btn-success btn-sm me-1"
                        title="Project marked as 'Completed'">
                        Completed
                    </button>
                {:else}
                    <button type="button" on:click={() => (isOpenComplete = true)}
                        class="btn  btn-outline-blue btn-sm me-1"
                        title="Mark your project as 'Complete', but doing so you will not be able to edit it, only review for print">
                        <span>Complete project</span>
                    </button>
                {/if}
                <button type="button" on:click={() => generateReport()}
                    class="btn btn-outline-blue btn-sm"
                    title="Preview to be printed of your project data from the current product configuration selected">
                    <span>Generate Report</span>
                </button>
            </div>
        </div>
        <div class="row mb-3 text-end mt-2">
            <div class="col-2">
                <label class="form-label">Project:</label>
            </div>
            <div class="col-4">
                {#if projectIsComplete}
                    <input type="text" class="form-control form-control-sm" value={currentProject.Name} disabled />
                {:else}
                    <input type="text" class="form-control form-control-sm"
                        placeholder="Project 1" maxlength="100"
                        bind:value={currentProject.Name}
                        on:focus={onFocusName}
                        on:blur={onBlurName}  />
                {/if}
            </div>
            <div class="col-6 text-end mt-2">
                <a href="!" on:click|preventDefault={() => goToColorData()} class="a-blue"
                    title="Jump to charts section">
                    Go to Color Data
                </a>
            </div>
        </div>
        <div class="row mb-3 text-end">
            <div class="col-2 ">
                <label class="form-label">Method:</label>
            </div>
            <div class="col-4">
                <input type="text" class="form-control form-control-sm" placeholder="Cie 76" value={currentProject.Method} disabled />
            </div>
        </div>
        <div class="row  mb-3 ">
            <div class="col-2 text-end">
                <span>Product/Configuration:</span>
            </div>
            <div class="col-4">
                <select id="productSelect" bind:value={projectProductId} class="form-select form-select-sm" disabled={userProjectProducts.length == 0}>
                    {#each userProjectProducts as product}
                        <option value={product.ID}>{product.Name}</option>
                    {:else}
                        <option value="0">&lt;--Add Product--&gt;</option>
                    {/each}
                </select>
            </div>
            <div class="col-4" style="display: flex;">
                {#if !projectIsComplete}
                    <button type="button" on:click={() => (isOpenProduct = true)}
                        class="btn btn-blue text-white btn-sm"
                        title="Add a product from your product configuration list available to start adding custom entries">
                        Add
                    </button>
                {/if}
            </div>
        </div>
    </div>
    <div class="col sm-6" />
</div>
<!-- end Project Base -->
{#if userProjectProducts.length > 0}
<Tooltip style="top: 290px; left: 55px; display: none;" position="right" number="4" title="" text="L*, a*, b* color target values are transferred automatically from International Glazing Database (IGDB) v76 that are part of Construct Tool for given glass/window configuration.  These values are a starting point, and after you collect enough data from your particular heat treating process, you can enter your own customized color target values." />
<Tooltip style="top: 170px; left: 750px; display: none;" position="top" number="5" title="" text="Δ Color Tolerance value is ASTM C1376 Standard default value (4.0 dE) loaded in initially.  This is the maximum allowable straight-line distance in 3-D color space from the color target (L*, a*, b*) your color data is allowed to fall within.  You can also enter your own customized Tolerance value (e.g. a smaller value internal limit to help ensure no color uniformity issues on building)." />
<Tooltip style="top: 555px; left: -80px; display: none;" position="bottom" number="6" title="" text="Unit #: You can add your own numbering scheme to keep track of total number of monolithic or IG units fabricated; can use to delineate separate tempering batch runs if desired and aid in traceability" />
<Tooltip style="top: 500px; left: 200px; display: none;" position="right" number="7" title="" text="Date: Useful to enter especially if separate tempering batch runs are executed for one project Vitro Ticket: Useful to enter to aid in traceability efforts if issues arise later" />
<Tooltip style="top: 555px; left: 505px; display: none;" position="bottom" number="8" title="" text="L*, a*, b*: Enter actual color readings from your heat-treated monolithic or IG unit using your spectrophotometer. It is recommended you enter at least two readings (data rows) for each monolithic or IGU piece" />
<Tooltip style="top: 390px; left: 600px; display: none;" position="top" number="9" title="" text="ΔE*ab: Evaluation of straight-line distance (dE) from individual color data point to Color Target in 3-D color space. If this value exceeds a customizable Color Tolerance limit, the cell will highlight yellow. If it exceeds the ASTM C1376 default value of 4.0, the cell will highlight red for easy identification." />
<Tooltip style="top: 555px; left: 810px; display: none;" position="bottom" number="10" title="" text="Actions: Here you can record your own notes on any follow-up action needed or completed for a particular monolithic piece or IG unit Vitro Ticket: Useful to enter to aid in traceability efforts if issues arise later" />

    <div class="row">
        <div class="col-12 ml-3">
            <table class="table table-bordered">
                <thead class="thead tbl-gray text-white">
                    <tr>
                        <th scope="col">L°</th>
                        <th scope="col">a°</th>
                        <th scope="col">b°</th>
                        <th scope="col">ΔE*ab Color Tolerance</th>
                    </tr>
                </thead>
                <tbody>
                    {#if currentProject.Nominal}
                        <tr>
                            <td>{currentProject.Nominal.MeasurementL}*</td>
                            <td>{currentProject.Nominal.MeasurementA}*</td>
                            <td>{currentProject.Nominal.MeasurementB}*</td>
                            <td>{currentProject.Nominal.MeasurementD}*</td>
                        </tr>
                    {/if}
                    {#if isOpenRowCustom}
                        <tr class="product-entry">
                            {#each customMeasures as custom, i}
                                {#if i > 0}
                                    <td>
                                        <div class="flex">
                                            <input type="number" bind:value={custom} />
                                        </div>
                                    </td>
                                {:else}
                                    <td>
                                        <div class="flex">
                                            <input bind:this={newCustomMeasure} bind:value={custom} type="number" />
                                        </div>
                                    </td>
                                {/if}
                            {/each}
                        </tr>
                    {:else if currentProject.Custom}
                        <tr>
                            {#each customMeasures as custom}
                                <td>{custom}</td>
                            {/each}
                        </tr>
                    {/if}
                </tbody>
            </table>
        </div>
        <div class="col-2  ml-3">
            <span>*Default Values</span>
        </div>
        <div class="col-10  ml-3 text-end">
            {#if !projectIsComplete}
                {#if isOpenRowCustom}
                    <button on:click={addCustom} type="button" class="btn btn-outline-blue btn-sm"
                        title="Save custom values">
                        <i class="bi bi-save" />
                        <span>Save</span>
                    </button>
                    <button on:click={onCustomizeCancel} type="button" class="btn btn-outline-danger btn-sm"
                        title="Cancel operation">
                        <i class="bi bi-x-lg" />
                        <span>Cancel</span>
                    </button>
                {:else}
                    <button on:click={() => (isOpenRowCustom = true)} type="button" class="btn btn-outline-blue btn-sm"
                        title="Start capturing custom color data values">
                        <i class="bi bi-pencil-square" />
                        <span>Customize</span>
                    </button>
                    {#if currentProject.Custom}
                        <button on:click={onDeleteCustom} type="button" class="btn btn-outline-red btn-sm"
                            title="Delete custom color data values">
                            <i class="bi bi-trash text-danger" />
                            <span>Delete customize</span>
                        </button>
                    {/if}
                {/if}
            {/if}
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12 text-end">
            <a class="btn-action" href="{Util.apiSegment + '/api/colorcalc/user_excel_template'}"
                title="Download excel file template so that you can put manually your entries and upload it on 'Upload raw data'">
                <i class="bi bi-file-earmark-excel-fill text-success fs-6" />
                <span>Raw data template</span>
            </a>
            <a class="btn-action" href="!" on:click|preventDefault={() => (isOpenUpload = true)}
                title="Upload your color data .csv file or your custom data using the excel file data template">
                <i class="bi bi-file-earmark-arrow-up-fill text-success fs-6" />
                <span>Upload raw data</span>
            </a>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12 ml-3">
            <table class="table table-bordered">
                <thead class="thead tbl-gray text-white">
                    <tr>
                        <td>Unit #</td>
                        <td>Date</td>
                        <td>Vitro Ticket</td>
                        <td>L°</td>
                        <td>a°</td>
                        <td>b°</td>
                        <td>ΔE*ab</td>
                        {#if !projectIsComplete}
                            <td>Actions</td>
                        {/if}
                    </tr>
                </thead>
                <tbody>
                    {#each entryPag as entry, i (entry.ID)}
                        <tr class="product-entry">
                            {#if entry.isEditing}
                                <!-- Unit # -->
                                <td>
                                    <div class="flex">
                                        <input class="fixed-width" bind:this={newEntryMeasure} type="number" bind:value={entry.edit.Number} />
                                    </div>
                                </td>
                                <!-- Date -->
                                <td>
                                    <div class="flex">
                                        <input bind:value={entry.edit.DateDt} type="datetime-local" >
                                    </div>
                                </td>
                                <!-- Ticket -->
                                <td>
                                    <div class="flex">
                                        <input class="fixed-width" bind:value={entry.edit.Ticket} type="text" maxlength="100" >
                                    </div>
                                </td>
                                <!-- L* -->
                                <td>
                                    <div class="flex">
                                        <input class="fixed-width" type="number" bind:value={entry.edit.MeasurementL} />
                                    </div>
                                </td>
                                <!-- a* -->
                                <td>
                                    <div class="flex">
                                        <input class="fixed-width" type="number" bind:value={entry.edit.MeasurementA} />
                                    </div>
                                </td>
                                <!-- b* -->
                                <td>
                                    <div class="flex">
                                        <input class="fixed-width" type="number" bind:value={entry.edit.MeasurementB} />
                                    </div>
                                </td>
                            {:else}
                                <td>{entry.Number || ''}</td>
                                <td>{Util.formatDate(entry.DateDt)}</td>
                                <td>{entry.Ticket || ''}</td>
                                <td>{entry.MeasurementL}</td>
                                <td>{entry.MeasurementA}</td>
                                <td>{entry.MeasurementB}</td>
                            {/if}
                            <td class="{setClass(entry.MeasurementD)} bg-opacity-25">{entry.MeasurementD}</td>
                            {#if !projectIsComplete}
                                <td class="flex-center">
                                    {#if entry.isEditing}
                                        <i on:click={editEntry(entry.edit)}
                                            class="btn-action pe-3 bi bi-save text-primary fs-5"
                                            title="Save changes" />
                                        <i on:click={async () => {
                                            delete entry.edit;
                                            entry.isEditing = false;
                                        }}
                                            title="Cancel changes"
                                            class="btn-action bi bi-x-lg text-danger fs-5"
                                        />
                                    {:else}
                                        <i on:click={() => {
                                            entry.edit = Object.assign({}, entry);
                                            entry.isEditing = true;
                                        }}
                                            title="Edit entry"
                                            class="btn-action pe-3 bi bi-pencil-square text-primary fs-5" />
                                        <i on:click={() => deleteEntry(entry.Ticket, entry.ID)}
                                            title="Delete entry"
                                            class="btn-action bi bi-trash text-danger fs-5" />
                                    {/if}
                                </td>
                            {/if}
                        </tr>
                    {/each}
                    {#if isOpenRowEntry}
                        <tr class="product-entry">
                            <!-- Unit # -->
                            <td>
                                <div class="flex">
                                    <input class="fixed-width" bind:this={newEntryMeasure} type="number" bind:value={entryMeasures[0]} />
                                </div>
                            </td>
                            <!-- Date -->
                            <td>
                                <div class="flex">
                                    <input bind:value={entryMeasures[1]} type="datetime-local" >
                                </div>
                            </td>
                            <!-- Ticket -->
                            <td>
                                <div class="flex">
                                    <input class="fixed-width" bind:value={entryMeasures[2]} type="text" maxlength="100" >
                                </div>
                            </td>
                            <!-- L* -->
                            <td>
                                <div class="flex">
                                    <input class="fixed-width" type="number" bind:value={entryMeasures[3]} />
                                </div>
                            </td>
                            <!-- a* -->
                            <td>
                                <div class="flex">
                                    <input class="fixed-width" type="number" bind:value={entryMeasures[4]} />
                                </div>
                            </td>
                            <!-- b* -->
                            <td>
                                <div class="flex">
                                    <input class="fixed-width" type="number" bind:value={entryMeasures[5]} />
                                </div>
                            </td>
                            <!-- delta -->
                            <td />
                            <td class="flex-center">
                                <i on:click={addEntry} class="btn-action pe-3  bi bi-save text-primary fs-5" />
                                <i on:click={onCancelEntry} class="btn-action bi bi-x-lg text-danger fs-5" />
                            </td>
                        </tr>
                    {/if}
                </tbody>
            </table>
            {#if entryTotalItems > entryItemsPerPag}
                <Pagination bind:current_page={entryCurrentPag} last_page={entryTotalPag} per_page={entryItemsPerPag} from={entryItemPagFm} to={entryItemPagTo} total={entryTotalItems} />
            {/if}
        </div>
    </div>
    <div class="row">
        <div class="col-12 ml-3">
            {#if !projectIsComplete}
                {#if !isOpenRowEntry}
                    <button on:click={() => (isOpenRowEntry = true)} type="button"
                        class="btn  btn-outline-blue btn-sm "
                        title="Add new color dada entry with custom values">
                        <i class="bi bi-plus-lg" />
                        <span>New Row</span>
                    </button>
                {/if}
            {/if}
        </div>
    </div>
    <div class="row mt-4" id="colorData">
        <div class="col-6" style={showChartAB ? "" : "display: none;"}>
            <div class="card">
                <div class="card-body" id="chartAB" />
            </div>
        </div>
        <div class="col-6" style={showChartLA ? "" : "display: none;"}>
            <div class="card">
                <div class="card-body" id="chartAL" />
            </div>
        </div>
        <div class="col-6" style={showChartLB ? "" : "display: none;"}>
            <div class="card">
                <div class="card-body" id="chartBL" />
            </div>
        </div>
        <br />
        <div class="col-12 d-flex flex-column justify-content-end text-end">
            <a href="!" on:click|preventDefault={goToTop} class="a-blue"
                title="Jump to TOP section">
                Back to the top
            </a>
        </div>
    </div>
{/if}
<Modal bind:open={isOpenProduct} dialogClasses="modal-lg modal-dialog-centered">
    <div class="modal-body">
        <div class="row">
            <div class="col-12 text-end">
                <button type="button" class="btn-close" on:click={() => (isOpenProduct = false)} aria-label="Close" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h5>Product / configuration</h5>
                Select the products to add into Color Calculator
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-4 text-end">
                <span>Select Product</span>
            </div>
            <div class="col-8">
                <div class="multiselect" on:click={showCheckboxes}>
                    <div class="selectBox">
                        <select class="form-select form-select-sm">
                            <option>&lt;--Add Product--&gt;</option>
                        </select>
                        <div class="overSelect" />
                    </div>
                    <div bind:this={checkboxes} id="checkboxes">
                        {#each userProducts as product}
                            <div class="product-available">
                                <label for={product.Id} class="ml-2">
                                    <input type="checkbox" bind:group={selectedProducts} name="products" value={product.ID} />
                                    {product.Name}
                                </label>
                                <hr />
                            </div>
                        {:else}
                            <label for="0" class="ml-2">
                                <input type="checkbox" id="0" disabled /> no products
                            </label>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 text-end">
                <button type="button" on:click={() => (isOpenProduct = false)}
                    class="btn btn-outline-blue mr-3"
                    title="Cancel operation">
                    Cancel
                </button>
                <button type="button" on:click={() => addProducts(false)}
                    class="btn btn-blue text-white mr-3"
                    title="Add selected product configuration to current project">
                    Add
                </button>
            </div>
        </div>
    </div>
</Modal>
<Modal bind:open={isOpenComplete} dialogClasses="modal-dialog-centered">
    <div class="modal-body">
        <div class="container-fluid" style="font-size: 16px;">
            <div class="row">
                <div class="col-12 text-end">
                    <button type="button" class="btn-close" on:click={() => (isOpenComplete = false)} aria-label="Close" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h5>Complete Project</h5>
                    Are you sure you want to complete and close this project? You will not be able to edit, but can still review for print.
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-end">
                    <button type="button" on:click={() => (isOpenComplete = false)}
                        class="btn btn-outline-blue me-md-2"
                        title="Cancel operation">
                        Cancel
                    </button>
                    <button type="button" on:click={() => setProjectComplete(currentProject.ID)}
                        class="btn btn-blue text-white"
                        title="Complete project">
                        Complete
                    </button>
                </div>
            </div>
        </div>
    </div>
</Modal>
<!-- Report -->
<Report bind:open={isOpenReport} {excelReportURL} logo={projectimgSrc}
    onSettings={() => isOpenCustomize = true}
    productName={userProjectProductSelectedName}
    project={currentProject}
    {showChartAB} {showChartLA} {showChartLB} {showData} />
<!-- Print Settings  -->
<PrintSettings bind:open={isOpenCustomize}
    onSave={saveCustomProject}
    project={currentProject}
    disabled={projectIsComplete}
    {showChartAB} {showChartLA} {showChartLB} {showData} />
<svelte:component this={component} bind:isOpen={isOpenConfirmation} {...confirmationProps} />
<ModalTemplate bind:isOpen={isOpenUpload} title="Upload Raw Data">
    <div slot="body" style="display: flex; flex-direction: column;">
        <div class="mb-3">
            <label for="colorDataFile" class="form-label">
                Select a file, it can be either with extension <strong>.csv</strong> or with extension <strong>.xlsx</strong>.
            </label>
            <input class="form-control" type="file" id="formFile" accept=".csv, .xlsx" bind:files={fileUpload}>
        </div>
        <div style="flex: 1; display: flex; justify-content: space-evenly;">
            <div class="file-action">
                <label>
                    <input type="radio" bind:group={action} name="action" value="append" />
                    <span title="Create new entries from file but still retaining previous data">
                        Appends
                    </span>
                </label>
            </div>
            <div class="file-action">
                <label>
                    <input type="radio" bind:group={action} name="action" value="override" />
                    <span title="Delete previous data created using either file type and create new entries from file selected">
                        Override
                    </span>
                </label>
            </div>
        </div>
    </div>
    <div slot="footer">
        <button type="button" on:click={() => (isOpenUpload = false)}
            class="btn btn-outline-primary mr-3 btn-sm"
            title="Cancel operation">
            <span>Cancel</span>
        </button>
        <button disabled={!(fileUpload.length > 0)} type="button" on:click={() => uploadFile()}
            class="btn btn-outline-success mr-3 btn-sm"
            title="Upload file selected (.csv or .xlsx">
            <span>Upload</span>
        </button>
    </div>
</ModalTemplate>

<style>
    a:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .btn-file {
        border: 2px dashed gray;
    }

    .btn-action:hover {
        cursor: pointer;
    }

    label:hover {
        cursor: default !important;
    }

    .multiselect {
        width: 100%;
    }

    .multiselect:hover {
        cursor: pointer;
    }

    .selectBox {
        position: relative;
    }

    .selectBox select {
        width: 100%;
    }

    .overSelect {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    #checkboxes {
        display: none;
        border: 1px #dadada solid;
        height: 200px;
        overflow: auto;
    }

    #checkboxes label {
        display: block;
    }

    #checkboxes label:hover {
        background-color: #1e90ff;
    }

    .btn-orange {
        background-color: #e67e22;
    }

    .btn-gray {
        background-color: #e5e7e9;
    }

    .btn-blue {
        background-color: #3cb1d6;
    }

    .btn-outline-blue {
        border: 2px solid black;
        background-color: white;
        border-color: #3cb1d6;
        color: #3cb1d6;
    }

    .btn-outline-red {
        border: 2px solid black;
        background-color: white;
        border-color: red;
        color: red;
    }

    .btn-chart-report {
        border-radius: 16px;
    }

    .tbl-gray {
        background-color: #3d4952;
    }

    a:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .a-blue {
        color: #3cb1d6;
    }

    .tbl-noPadding {
        border-collapse: collapse;
    }

    .tbl-black-values {
        font-size: 20px !important;
    }

    .tbl-gray-values {
        font-size: 10px !important;
        color: gray;
    }

    .text-blue {
        color: #1f81a0;
    }

    .text-gray {
        color: gray;
    }

    hr {
        margin: 0 !important;
    }

    .modal-footer-report {
        display: block;
    }

    .ml-2 {
        padding: 10px;
    }

    .ml-2:hover {
        cursor: pointer !important;
        background-color: #3cb1d6 !important;
    }

    .file-action {
        padding: 10px;
    }

    .flex {
        display: flex;
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .product-entry .flex input {
        flex: 1;
        padding: 5px;
    }

    .product-entry .fixed-width {
        width: 80px;
    }
</style>
